module.exports = __webpack_public_path__ + "img/gmail.c0296f2.png";